var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsTreatment = function SvgMetricsTreatment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45 24-6.151 14.85L24 45 9.151 38.85 8.385 37c2.054-.567 3.839-1.211 5.407-1.924 6.213-2.823 8.907-6.642 11.433-10.209 2.474-3.495 4.78-6.74 10.223-9.213 1.504-.683 3.255-1.31 5.324-1.862z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.849 9.151 39.613 11c-2.053.567-3.837 1.212-5.405 1.925-6.213 2.823-8.907 6.642-11.433 10.209-2.474 3.495-4.78 6.74-10.223 9.213-1.504.683-3.255 1.31-5.324 1.861L3 24 9.151 9.151 24 3z"
  })));
};
export default SvgMetricsTreatment;